module.exports = __webpack_public_path__ + "static/media/weekendPaceBellPepper.de794081.png";